export const collapseCategorySearch = (value: string) =>
  value.toLowerCase().replace(/\s+/g, '');

export const categorySearchMatches = (haystack: string, needle: string) => {
  if (!needle) return true;
  return collapseCategorySearch(haystack).includes(needle);
};
